import React from "react";
import "./CartCard.scss";
import * as shopActions from "../../../actions/shop";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import promo from "../../../images/special.png";
import delete_icon from "../../../images/cart/delete.png";
import moment from "moment";
import formatPrice from "../../../helpers/formatPrice";

const CartCard = (props) => {
  const history = useHistory();
  const { t } = useTranslation();

  const item = props.item.product;
  const ordered = props.item.ordered || props.ordered;

  const checkPlusAmount = (fl) => {
    const unitsInPackage = Number(fl.item.variation.unitsInPackage || 1);
    const availableQuantity = Number(fl.item.product.quantity || 0);
    const currentQuantity = Number(fl.item.quantity || 0);

    return (currentQuantity + 1) * unitsInPackage <= availableQuantity;
  };

  const checkMinusAmount = (fl) => {
    return Number(fl.item.quantity) < 2;
  };

  const setCursor = (e) => {
    e.target.scrollTop = 50;
    e.currentTarget.setSelectionRange(
      e.currentTarget.value.length,
      e.currentTarget.value.length
    );
  };

  const getRowTotal = () => {
    if (props.item.totalPrice !== undefined) {
      return formatPrice(props.item.totalPrice || 0);
    }

    return formatPrice(
      Number(props.item.quantity || 0) *
        Number(props.item.variation.unitsInPackage || 1) *
        Number(props.item.variation.unitPrice || 0)
    );
  };

  const renderComment = () => {
    if (ordered) {
  return props.item.note ? (
    <div className="cart-card__comment cart-card__comment--readonly">
      <div className="cart-card__comment-label">
        {t("cartPage.comment")}
      </div>

      <div className="textarea">{props.item.note}</div>
    </div>
  ) : null;
}

    if (props.item.editNote === true) {
      return (
        <div className="cart-card__comment cart-card__comment--edit">
          <textarea
            autoFocus
            maxLength={255}
            onFocus={setCursor}
            onChange={(e) => props.editNoteHandler(props.item.id, e)}
            value={props.item.note || ""}
            placeholder={t("cartPage.commentPlaceholder")}
          />

          <Button
            type="button"
            className="comment_button save"
            onClick={() =>
              props.saveComment(props.item.id, props.item.note || "")
            }
          >
            {t("save")}
          </Button>
        </div>
      );
    }

    return (
      <div className="cart-card__comment">
        {props.item.note ? (
          <div className="textarea">{props.item.note}</div>
        ) : (
          <div className="textarea textarea--empty">
            {t("cartPage.commentPlaceholder")}
          </div>
        )}

        <button
          type="button"
          className="comment_button"
          onClick={() => props.editComment(props.item.id)}
        >
          {props.item.note ? t("cartPage.comment") : t("cartPage.addComment")}
        </button>
      </div>
    );
  };

  return (
    <div className="Cart-card">
      <div className="cart-card__product" data-label={t("cartPage.product")}>
        <div className="cart-card__product-inner">
          <div className="cart-card__image">
            <img src={item.photoLink} alt={item.fullName} />

            {item.specialOffer ? (
              <img className="promo" src={promo} alt="" />
            ) : null}
          </div>

          <div className="cart-card__product-text">
            <h3>{item.fullName}</h3>
            <p>{formatPrice(props.item.variation.unitPrice)} €</p>
          </div>
        </div>
      </div>

      <div className="cart-card__info" data-label={t("cartPage.productInfo")}>
        <div className="cart-card__info-grid">
          <div>
            <p>
              {t("product.length")}: {item.height}
            </p>
            <p>
              {t("product.available")}: {item.quantity}
            </p>
            <p>
              {t("product.quality")}: {item.quality}
            </p>
          </div>

          <div>
            <p>
              {t("product.color")}: {item.color}
            </p>
            <p>
              {t("product.supplier")}: {item.grower}
            </p>
          </div>
        </div>
      </div>

      <div className="cart-card__date" data-label={t("cartPage.deliveryDate")}>
        {props.date
          ? moment(props.date).isValid()
            ? moment(props.date).format("YYYY MM DD")
            : props.date
          : ""}
      </div>

      <div className="cart-card__controls" data-label={t("cartPage.quantity")}>
        {!ordered ? (
          <div className="cart-card__controls-row">
            <div className="cart-card__count">
              <button
                type="button"
                className={checkMinusAmount(props) ? "disabled" : ""}
                onClick={
                  !checkMinusAmount(props)
                    ? () =>
                        props.changeAmount(
                          props.item.id,
                          props.item.quantity - 1
                        )
                    : undefined
                }
              >
                −
              </button>

              <span>{props.item.quantity}</span>

              <button
                type="button"
                className={!checkPlusAmount(props) ? "disabled" : ""}
                onClick={
                  checkPlusAmount(props)
                    ? () =>
                        props.changeAmount(
                          props.item.id,
                          props.item.quantity + 1
                        )
                    : undefined
                }
              >
                +
              </button>
            </div>

            <button
              type="button"
              className="cart-card__delete"
              onClick={() => props.removeItem(props.item.id, history)}
            >
              <img src={delete_icon} alt="" />
              {t("cartPage.delete")}
            </button>
          </div>
        ) : (
          <div className="cart-card__ordered">{t("ordered")}</div>
        )}
      </div>

      <div className="cart-card__total" data-label={t("cartPage.total")}>{getRowTotal()} €</div>

      {renderComment()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  cart: state.shop.cart,
  cartTemp: state.shop.cartTemp,
  note: state.shop.note,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(shopActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartCard);
